import { createTheme } from "react-data-table-component";

/* One table theme. react-data-table-component paints loading and "no records"
   boxes from the default theme, and those boxes have no class. The Documents
   skin in react-dataTable-component.scss paints the same boxes, plus header,
   rows, hover, and the pager. Both read --cd-table-surface and --cd-table-text.

   The light mixin sets those tokens (surface is --cd-card, text is --cd-text).
   body.dark-layout overrides them. Print includes the light mixin, so export
   stays on the light card. No hardcoded colour: an unset token must not fall
   back to the library's white / near-black, or dark and light would diverge
   from the skin. */
export const DATA_TABLE_THEME = {
  text: { primary: "var(--cd-table-text)" },
  background: { default: "var(--cd-table-surface)" },
};

createTheme("default", DATA_TABLE_THEME);
